/* oxlint-disable @fullscript/gql-file-usage */
import type { MutationHookOptions } from "@apollo/client";
import { useMutation, gql } from "@apollo/client";

import { CERTIFICATION_FRAGMENT } from "@shared/data/fragments/CertificationFragment/CertificationFragment.fragment";
import type { CertificationFragment } from "@shared/data/fragments/CertificationFragment/CertificationFragment.fragment";

const PractitionerCertificationCreate_Shared_Mutation = gql`
  mutation PractitionerCertificationCreate_Shared_Mutation(
    $input: PractitionerCertificationCreateInput!
  ) {
    practitionerCertificationCreate(input: $input) {
      certification {
        ...CertificationFragment
      }
      errors {
        message
        fields {
          certificate
        }
      }
    }
  }
  ${CERTIFICATION_FRAGMENT}
`;

interface PractitionerCertificationCreateData {
  practitionerCertificationCreate: {
    certification: CertificationFragment;
    errors: {
      message: string;
      fields: {
        certificate: string[];
      };
    };
  };
}

interface Variables {
  input: {
    attributes: {
      certificate: File;
    };
  };
}

const usePractitionerCertificationCreateMutation = (
  options?: MutationHookOptions<PractitionerCertificationCreateData, Variables>
) =>
  useMutation<PractitionerCertificationCreateData, Variables>(
    PractitionerCertificationCreate_Shared_Mutation,
    options
  );

export type { PractitionerCertificationCreateData };

/* oxlint-disable @fullscript/gql-no-manual-hook-declaration */
export {
  usePractitionerCertificationCreateMutation,
  PractitionerCertificationCreate_Shared_Mutation,
};
